<template>
  <div class="plan-list">
    <QueryFrame
      @handlePage='handlePage'
      @handlePageSize='handlePageSize'
      :count='count'
      :current="page"

    >
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem" v-if="roleType!==2">
            <label>业务机构名称:</label>
            <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
          </div>
          <div class="queryItem">
            <label>起始月:</label>
            <timeStampDatePicker  type="month" v-model='query.startTime' class="item" :options="beginDateOptions"></timeStampDatePicker>
          </div>
          <div class="queryItem">
            <label>结束月:</label>
            <timeStampDatePicker type="month" v-model='query.endTime' class="item" :options="endDateOptions"></timeStampDatePicker>
          </div>
           <div class="queryItem">
            <label>商品分类:</label>
            <div class="item">
              <TreeSelect v-model.trim="query.categoryIdList" :data="indicationTree" :props="{title: 'label', value: 'value', children: 'children'}"></TreeSelect>
            </div>
         </div>
          <div class="queryItem">
            <label>GSP分类:</label>
            <lk-select v-model='query.labelIdList' class="item" clearable multiple >
              <lk-option v-for="(item,index) in labels" :key="index" :value='item.id'>{{item.name}}</lk-option>
            </lk-select>
          </div>
          <div class="queryItem">
            <label>是否DTP:</label>
            <lk-select v-model='query.isDtp' class="item" clearable  >
              <lk-option :value='1'>是</lk-option>
              <lk-option :value='2'>否</lk-option>
            </lk-select>
          </div>
           <!-- <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for='(item ,i) in getGoodsOrigin' :key="i" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div> -->
          <div class="queryItem">
            <lk-button class="mr" type='primary' @click="handleSearch(false, getTotal)">查询</lk-button>
            <lk-button @click="clear" class="mr">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="report-btns-wrap btn">
          <exportAsync  class="mr" v-if="handlePermission('inventoryTurnoverAnalysisByStoreExport')" @on-click='handleExport'></exportAsync>
          <lk-button type="primary" class="mr" @click='refreshTime'>刷新今日报表</lk-button>
          <div v-if="deadline">数据截止至 {{deadline}}</div>
        </div>

        <div class="Report-total-container">
          <div class="Report-total-title">合计</div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">平均存货额(S):</div>
            <div class="Report-total-item-value">{{total.averageInventoryStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">累计销售成本(O):</div>
            <div class="Report-total-item-value">{{total.costAmountWithoutTaxStr}}</div>
          </div>
          <!-- <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">不含税毛利率(R):</div>
            <div class="Report-total-item-value">{{total.profitRateWithoutTax}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">周转次数(T=O/S):</div>
            <div class="Report-total-item-value">{{total.turnoverCountStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">交叉比率(R*T):</div>
            <div class="Report-total-item-value">{{total.crossRatio}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">周转天数(P/T):</div>
            <div class="Report-total-item-value">{{total.turnoverDaysStr}}</div>
          </div>
          <div class="Report-total-item-wrap">
            <div class="Report-total-item-label">年周转次数(365/V):</div>
            <div class="Report-total-item-value">{{total.annualTurnoverStr}}</div>
          </div> -->
        </div>
        <lk-table
          border
          :columns='columns'
          :data='tableData'
          ></lk-table>
      </div>
    </QueryFrame>

  </div>
</template>
<script>
// import moment from 'moment';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import utils from '../../libs/utils';
// import goodsService from '@/services/goods';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import reportService from '../../services/report';
import exportAsync from '../../components/report/ExportAsync.vue';
import reportMixin from './reportMixin.js';
import TreeSelect from '../../components/treeSelect/treeSelect.vue';

export default {
  name: 'inventoryTurnoverAnalysisByStoreList',
  mixins: [mapState, queryMixins, reportMixin],
  components: {
    QueryFrame, exportAsync, TreeSelect,
  },
  data() {
    return {
      query: {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
      },
      beginDateOptions: {
        disabledDate: (date) => {
          if (date && this.query.endTime) {
            return date.valueOf() > this.query.endTime;// .valueOf();
          }
        },
      },
      endDateOptions: {
        disabledDate: (date) => {
          if (date && this.query.startTime) {
            return date.valueOf() < this.query.startTime;// .valueOf();
          }
        },
      },
      columns: [
        {
          title: '序号',
          minWidth: 60,
          render: (h, { index }) => h('div', index + 1),
        },
        {
          title: '区间',
          key: 'date',
          minWidth: 116,
        },
        {
          title: '跨度(P)',
          key: 'spans',
          minWidth: 116,
        },
        {
          title: '业务机构',
          key: 'storeVoStoreCode',
          minWidth: 116,
        },
        {
          title: '业务机构名称',
          key: 'storeVoStoreName',
          minWidth: 116,
        },
        {
          title: '平均存货额(S)',
          key: 'averageInventoryStr',
          minWidth: 116,
        },
        {
          title: '累计销售成本(O)',
          key: 'costAmountWithoutTaxStr',
          minWidth: 116,
        },
        {
          title: '不含税毛利率(R)',
          key: 'profitRateWithoutTax',
          minWidth: 116,
        },
        {
          title: '周转次数(T=O/S)',
          key: 'turnoverCountStr',
          minWidth: 116,
        },
        {
          title: '交叉比率(R*T)',
          key: 'crossRatio',
          minWidth: 116,
        },
        {
          title: '周转天数(V=P/T)',
          key: 'turnoverDaysStr',
          minWidth: 116,
        },
        {
          title: '年周转次数(365/V)',
          key: 'annualTurnoverStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      total: {},
    };
  },
  methods: {
    clear() {
      this.query = {
        startTime: utils.getCurrentMonthTimestamp(),
        endTime: utils.getNextMonthTimestamp(),
        storeIdList: [],
      };
    },
    getTotal() {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      reportService.inventoryTurnoverAnalysisByStoreTotal(utils.deletePageAndSize(this.params)).then((res) => {
        if (res.data.status === 200) {
          const data = res.data.data;
          if (data.startTime && data.endTime) {
            data.date = `${utils.formatTime(data.startTime, 'YYYY-MM-DD')}至${utils.formatTime(data.endTime, 'YYYY-MM-DD')}`;
          } else {
            data.date = '';
          }
          this.total = data || {};
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        console.log(err);
        utils.handleError(err);
      });
    },
    handleExport(info, func) {
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      this.$store.commit('setDisableLoading', true);
      reportService.inventoryTurnoverAnalysisByStoreExport(utils.deletePageAndSize(this.params))
        .then((res) => {
          if (res.data.status === 200) {
            func(res.data.data);
          } else {
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      // this.params.startTime = this.params.startTime && new Date(this.params.startTime).getTime();
      // this.params.endTime = this.params.endTime && new Date(this.params.endTime).getTime();
      if (!this.params.startTime || !this.params.endTime) {
        this.$Message.error('请输入起止月');
        return;
      }

      reportService.inventoryTurnoverAnalysisByStore(this.params).then((res) => {
        if (res.data.status === 200 && res.data.data.list) {
          this.tableData = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            if (result.startTime && result.endTime) {
              result.date = `${utils.formatTime(result.startTime, 'YYYY-MM-DD')}至${utils.formatTime(result.endTime, 'YYYY-MM-DD')}`;
            } else {
              result.date = '';
            }
            this.tableData.push(result);
          });
        } else if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
    this.fetchListIndications();
    this.getLabel();
    this.handleSearch(true, this.getTotal);
    this.getRefreshTime();
  },
};
</script>
<style lang="less" scoped>
  .btn{
    margin-bottom: 12px
  }
</style>
